import { Component, OnInit, OnDestroy } from "@angular/core";
import { Store, Action } from "@ngrx/store";
import { Actions } from "@ngrx/effects/src/actions";
import { AppState } from "@store/app-state";
import { Subscription } from "rxjs/Subscription";
import { EnrolmentsStore } from "@store/enrolment";
import { Enrolment } from "@models/enrolment";
import { MatrixClass } from "@models/matrix-class";
import { ConstantsStore } from "@store/constants";
import { Term } from "@models/term";
import {
  FETCH_POTENTIAL_CLASSES,
  CHANGE_CLASS_ON_ENROLMENT,
  CHANGE_CLASS_ON_ENROLMENT_SUCCESS,
  CHANGE_CLASS_ON_ENROLMENT_FAILURE
} from "@reducers/enrolments";
import { ClassIndexParams } from "@services/matrix-class";
import { ChangeClassParams } from "@services/enrolment";
import { ModalService } from "@services/modal";

@Component({
  selector: 'change-class-form',
  templateUrl: './change-class-form.pug',
})
export class ChangeClassFormComponent implements OnInit, OnDestroy {

  private enrolmentsSubscription: Subscription

  public enrolment: Enrolment
  public potentialClasses: MatrixClass[]
  public selectedClassId: number

  constructor(
    private store: Store<AppState>,
    private actions: Actions,
    private modalService: ModalService,
  ) {}

  ngOnInit() {
    this.enrolmentsSubscription = 
      this.store.select("enrolmentsReducer").subscribe((s: EnrolmentsStore) => {
        this.enrolment          = s.editableEnrolment
        this.potentialClasses   = s.potentialClasses
      })
    this.setAvailableClasses()
    this.setInitialState()
  }

  setAvailableClasses() {
    const payload: ClassIndexParams = {
      termId: this.enrolment.matrixClass.termId,
      courseId: this.enrolment.matrixClass.courseId
    }
    this.store.dispatch({ type: FETCH_POTENTIAL_CLASSES, payload })
  }

  setInitialState() {
    return this.selectedClassId == this.enrolment.matrixClassId
  }

  getFilteredPotentialClasses(): MatrixClass[] {
    return this.potentialClasses.filter((mc) => {
      return mc.id != this.enrolment.matrixClassId })
  }

  clickedClass(mc: MatrixClass) {
    this.selectedClassId = mc.id
  }

  clickedChangeClass() {
    const payload: ChangeClassParams = {
      enrolment_id: this.enrolment.id,
      matrix_class_id: this.selectedClassId
    }

    this.actions
      .ofType(CHANGE_CLASS_ON_ENROLMENT_SUCCESS, CHANGE_CLASS_ON_ENROLMENT_FAILURE)
      .take(1)
      .subscribe((a: Action) => {
        if (a.type == CHANGE_CLASS_ON_ENROLMENT_SUCCESS) {
          this.modalService.closeModal()
        }
      })

    this.store.dispatch({ type: CHANGE_CLASS_ON_ENROLMENT, payload })
  }

  getPendingEnrolments(mc: MatrixClass): number {
    return mc.enrolments.filter((n) => n.isPending).length }

  getActiveEnrolments(mc: MatrixClass): number {
    return mc.enrolments.filter((n) => !n.isPending).length }

  isClassSelected(mc: MatrixClass) {
    return this.selectedClassId == mc.id }

  ngOnDestroy() {
    this.enrolmentsSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/change-class-form.ts